import { Box, Button, Card, Stack, Typography } from '@mui/material';

import { BoostDuration } from '../BoostCard/styles';

import MARGIN_BOOST_2H_BADGE from '../../../../assets/images/store/MARGIN_BOOST_2H_BADGE.png';
import MARGIN_BOOST_4H_BADGE from '../../../../assets/images/store/MARGIN_BOOST_4H_BADGE.png';
import MARGIN_BOOST_8H_BADGE from '../../../../assets/images/store/MARGIN_BOOST_8H_BADGE.png';
import MARGIN_BOOST_12H_BADGE from '../../../../assets/images/store/MARGIN_BOOST_12H_BADGE.png';
import MARGIN_BOOST_24H_BADGE from '../../../../assets/images/store/MARGIN_BOOST_24H_BADGE.png';

import {
  badgeImgSx,
  emptyOverlaySx,
  getCardSx,
  hoursTextSx,
  quantityTextSx,
  subtitleTextSx,
  titleStackProps,
} from './styles';
import React from 'react';

const badgeByDuration: Record<BoostDuration, string> = {
  2: MARGIN_BOOST_2H_BADGE,
  4: MARGIN_BOOST_4H_BADGE,
  8: MARGIN_BOOST_8H_BADGE,
  12: MARGIN_BOOST_12H_BADGE,
  24: MARGIN_BOOST_24H_BADGE,
};

const titleByDuration: Record<BoostDuration, string> = {
  2: '2 Hours',
  4: '4 Hours',
  8: '8 Hours',
  12: '12 Hours',
  24: '24 Hours',
};

interface InventoryCardProps {
  duration: BoostDuration;
  quantity: number;
  onClick: () => void;
}

const InventoryCard: React.FC<InventoryCardProps> = ({
  duration,
  quantity,
  onClick,
}) => {
  const isEmpty = quantity <= 0;

  return (
    <Card sx={getCardSx(isEmpty)}>
      {isEmpty && <Box sx={emptyOverlaySx} />}

      <Typography sx={quantityTextSx}>x{quantity}</Typography>

      <Box component="img" src={badgeByDuration[duration]} sx={badgeImgSx} />

      <Stack {...titleStackProps}>
        <Typography sx={hoursTextSx}>{titleByDuration[duration]}</Typography>
        <Typography sx={subtitleTextSx}>Margin Boost</Typography>
      </Stack>

      <Button variant="contained" fullWidth onClick={onClick} sx={{ whiteSpace: 'nowrap' }}>
        Boost now
      </Button>
    </Card>
  );
};

export default InventoryCard;
